// src/data/rpaData.js
import teamImg from '../../assets/rpa-home/teamImg.webp';
import remoteImg from '../../assets/rpa-home/remoteImg.webp';
import careImg from '../../assets/rpa-home/careImg.webp';

const rpaData = {
  title: "Digitale Lösungen für moderne Unternehmen",
  tabs: [
    {
      id: "team",
      label: "Individuelle Teams",
      heading: "Maßgeschneiderte Teams für jedes Projekt",
      text: `Bei uns gibt es keine Lösung von der Stange. Wir stellen für jedes Projekt ein maßgeschneidertes Team zusammen – exakt abgestimmt auf Ihre Anforderungen, den Umfang und das Budget. Ob kleines MVP, umfassende Plattform oder langfristige Weiterentwicklung: Wir liefern genau die Expertise und Teamgröße, die Sie wirklich brauchen.`,
      image: teamImg,
    },
    {
      id: "remote",
      label: "Remote & Hybrid",
      heading: "Flexibles Arbeiten – deutschlandweit",
      text: `Als moderne Digitalagentur sind wir vollständig remote und hybrid aufgestellt. Das bedeutet: Wir arbeiten ortsunabhängig, agil und flexibel – und richten uns dabei ganz nach Ihren Bedürfnissen. Ob per Video-Call, Chat, E-Mail oder vor Ort – wir sind für Sie da, egal ob in Köln, München oder Berlin. So erhalten Sie erstklassige Ergebnisse ohne Umwege, deutschlandweit.`,
      image: remoteImg,
    },
    {
      id: "care",
      label: "Wartung",
      heading: "Wartung & Weiterentwicklung",
      text: `Wir begleiten Ihr Produkt auch nach dem Launch: Mit regelmäßiger Wartung, Sicherheitsupdates und funktionaler Weiterentwicklung sorgen wir für Langlebigkeit und kontinuierliche Optimierung Ihrer digitalen Lösung.`,
      image: careImg,
    },
  ],
};

export default rpaData;
